module.exports = __webpack_public_path__ + "img/liuxihesenlingongyuan.6fccc399.png";